import PurchaseRequestDetail from '@/models/PurchaseRequest/PurchaseRequestDetail';

export default class PurchaseRequestDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.purchaseRequestId  = '';
		this.purchaseRequestPurchaseRequestNumber = '';
		this.partName = '';
		this.qty = '';
		this.uom = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partId : '0',
			partPartNumber : '0',
			purchaseRequestId : '0',
			purchaseRequestPurchaseRequestNumber : '0',
			partName : '0',
			qty : '0',
			uom : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}